import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var NewlinesPipe = (function () {
    function NewlinesPipe() {
    }
    NewlinesPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
    };
    return NewlinesPipe;
}());
export { NewlinesPipe };
NewlinesPipe.decorators = [
    { type: Pipe, args: [{
                name: 'newlines'
            },] },
];
/** @nocollapse */
NewlinesPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=newlines.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/newlines.pipe.js
// module id = 282
// module chunks = 103